<template>
  <div>
    <page-header
      title="Sales Margin"
      breadcrumb="Accounting > Chart of Accounts"
    />
    <section>
      <div class="flex border-b-2 border-gray-400 pt-3 px-3 bg-white">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'sales' }"
          @click="currentTab = 'sales'"
        >
          <p>Sales</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'cost' }"
          @click="currentTab = 'cost'"
        >
          <p>Cost of Goods Sold</p>
        </div>
      </div>

      <div class="bg-white py-3 px-2 flex items-center w-full justify-between">
        <div>
          <img src="@/assets/images/icons/filter-icon.svg" class="ml-1" />
        </div>
        <div class="select">
          <el-select
            v-model="category"
            class="w-full"
            placeholder="--Cost Centre--"
          >
            <el-option
              v-for="type in ['cardTypes']"
              :key="type"
              :label="type"
              :value="type"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select">
          <el-date-picker v-model="startDate" placeholder="--Date From--" />
        </div>
        <div class="w-1"></div>
        <div class="select">
          <el-date-picker v-model="endDate" placeholder="--Date To--" />
        </div>
        <div class="w-4/12 flex justify-end">
          <button
            class="py-1 px-3 bg-primary-yellow text-white my-3 rounded-md"
          >
            <el-dropdown class="h-full">
              <button
                :disabled="false"
                :class="{ disabledDrop: !terms }"
                class="payment-assign h-full font-semibold rounded flex items-center p-2"
              >
                <span class="border-r border-white  mr-3 pr-2">{{
                  currentTab == "sales" ? "Add Sales Data" : "Add Purchase Data"
                }}</span>

                <arrow-down-filled />
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button @click="addManually">
                    Add Manually
                  </button>
                </el-dropdown-item>

                <el-dropdown-item>
                  <button @click="routeToImport">Import from File</button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </button>
        </div>
      </div>

      <div class="py-2 justify-end w-full flex">
        <button
          class="w-12 h-12 bg-white rounded flex justify-center items-center"
        >
          <img src="@/assets/images/icons/reload-icon.svg" />
        </button>
      </div>

      <div>
        <component :is="activeComponent" :currentTabProp="currentTabProp" />
      </div>
    </section>
    <AddSalesData :show-modal="showAddManually"
    @close-modal="showAddManually = false"/>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Sales from "@/components/3pl/Accounting/Sales/Sales.vue";
import Cost from "@/components/3pl/Accounting/Cost/Cost.vue";
import AddSalesData from "@/components/3pl/Accounting/Sales/modals/AddSalesData.vue";

export default {
  components: { PageHeader, Sales, Cost, AddSalesData },
  data() {
    return {
      searchString: "",
      category: "",
      currentTab: "sales",
      startDate: "",
      endDate: "",
      currentTabProp: "default",
      showAddManually: false
    };
  },
  methods: {
    addManually(){
      this.currentTabProp = 'manual'
      this.showAddManually = true
    },
    routeToImport() {
      this.currentTab == "sales"
        ? this.$router.push("/accounting/import-file/sales")
        : this.$router.push("/accounting/import-file/cost");
    },
  },
  computed: {
    activeComponent() {
      return this.currentTab == "sales" ? "sales" : "cost";
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 15%;
  height: auto;
  margin-top: 13px;
}
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
